import { MapContainer } from 'react-leaflet';
import styled from 'styled-components';

export const StyledMapContainer = styled(MapContainer)`
  width: 100%;
  height: 450px;
  > p {
    position: absolute;
    bottom: 0;
    font-family: 'Lato';
    margin: 0;
    padding: 12px;
    z-index: 1000;
    background-color: ${({ theme }) => theme.colors.white};
    font-weight: bold;
    color: ${({ theme }) => theme.colors.blue};
  }
  @media screen and (max-width: 690px) {
    height: 300px;
  }
  .leaflet-popup-content {
    width: 120px;
  }
  .leaflet-popup {
    left: -80px;
  }
`;

export const SpecialtiesWrapper = styled.div`
  display: inline-block;
  width: fit-content;
  height: 32px;
  box-sizing: border-box;
  background-color: #2a71d41a;
  border-radius: 6px;
  line-height: 32px;
  padding: 0 ${({ theme }) => theme.spacing * 2}px 
    0 ${({ theme }) => theme.spacing * 4}px;
  margin-right: ${({ theme }) => theme.spacing * 3}px;
  cursor: pointer;
  > p {
    font-size: 14px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.blue};
    opacity: .87;
    margin: 0;
    &::after {
      content: '+';
      margin-left: ${({ theme }) => theme.spacing * 2}px;
      color: ${({ theme }) => theme.colors.primary};
      opacity: .54;
    }
  }
`;

export const DeleteButton = styled.button`
  display: block;
  outline: none;
  margin: ${({ theme }) => theme.spacing * 2}px auto 0;
  border: none;
  background-color: unset;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  text-transform: uppercase;
  padding: 0;
  font-weight: bold;
  cursor: pointer;
`;
